/**
 * Video wall playback.
 *
 * Videos carry no `src` until the visitor presses play, so a wall of clips
 * costs only its poster images on load. Starting one clip pauses any other,
 * because two soundtracks at once is never what anyone wants.
 */
(function () {
  'use strict';

  let current = null;

  function attachSource(video) {
    if (video.src || !video.dataset.src) return;
    video.src = video.dataset.src;
  }

  function stop(item) {
    const video = item.querySelector('[data-ugc-video]');
    video?.pause();
    item.dataset.playing = 'false';
    const sound = item.querySelector('[data-ugc-sound]');
    if (sound) sound.hidden = true;
    if (current === item) current = null;
  }

  document.addEventListener('click', async (event) => {
    const playButton = event.target.closest('[data-ugc-play]');
    const soundButton = event.target.closest('[data-ugc-sound]');
    if (!playButton && !soundButton) return;

    const item = (playButton || soundButton).closest('[data-ugc-item]');
    const video = item?.querySelector('[data-ugc-video]');
    if (!video) return;

    if (soundButton) {
      video.muted = !video.muted;
      soundButton.setAttribute('aria-pressed', String(video.muted));
      return;
    }

    if (item.dataset.playing === 'true') {
      stop(item);
      return;
    }

    if (current && current !== item) stop(current);

    attachSource(video);
    item.dataset.playing = 'true';
    const sound = item.querySelector('[data-ugc-sound]');
    if (sound) sound.hidden = false;
    current = item;

    try {
      await video.play();
    } catch {
      // Autoplay policies or a missing file: fall back to the poster.
      stop(item);
    }
  });

  // A clip scrolled out of the rail should not keep playing off-screen.
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && entry.target.dataset.playing === 'true') stop(entry.target);
        });
      },
      { threshold: 0.25 }
    );

    function observeAll(scope) {
      scope.querySelectorAll('[data-ugc-item]').forEach((item) => observer.observe(item));
    }

    observeAll(document);
    document.addEventListener('shopify:section:load', (event) => observeAll(event.target));
  }
})();
